<template lang="pug">
.mg-game__timer
  countdown.mg-game__timer-list(:time="getSecondsLeft * 1000")
    template(slot-scope="timer")
      template(v-for="value in getTimerValues")
        .mg-game__timer-item
          .mg-game__timer-item-value {{ timer[value] }}
          .mg-game__timer-item-label {{ getLabelTitle(timer[value], value) }}
        .mg-game__timer-sep :
</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapState } = createNamespacedHelpers(mg_global);

export default {
  computed: {
    ...mapState(["current_time", "ends_at"]),

    getSecondsLeft() {
      let result = this.ends_at - this.current_time;
      if (result > 0) {
        return result;
      }
      return 0;
    },

    getTimerValues() {
      return ["days", "hours", "minutes"];
    },
  },
  methods: {
    getLabelTitle(value, type) {
      const text = this.$t("timer")[type];
      const last_digit = value % 10;

      if (last_digit === 1 && value !== 11) {
        return text[0];
      } else if (last_digit > 1 && last_digit < 5 && !(value >= 12 && value <= 14)) {
        return text[1];
      } else {
        return text[2];
      }
    },
  },
};
</script>
